/* ========================================
   BK-MEDIA CUSTOM JAVASCRIPT
   ======================================== */

document.addEventListener('DOMContentLoaded', function() {
  // Fix for country selector requiring double-click to close
  function fixCountrySelectorDoubleClick() {
    const countrySelectorButtons = document.querySelectorAll('.bk-media-mobile-nav__bottom-link--country-selector button[aria-controls]');
    
    countrySelectorButtons.forEach(button => {
      // Remove any existing click listeners that might interfere
      button.removeEventListener('click', handleCountrySelectorClick);
      
      // Add our custom click handler
      button.addEventListener('click', handleCountrySelectorClick, { capture: true });
    });
  }
  
  function handleCountrySelectorClick(event) {
    const button = event.target.closest('button[aria-controls]');
    if (!button) return;
    
    const popoverId = button.getAttribute('aria-controls');
    const popover = document.getElementById(popoverId);
    
    if (!popover) return;
    
    // Check if popover is currently open
    const isOpen = popover.hasAttribute('open');
    
    if (isOpen) {
      // If open, close it
      popover.removeAttribute('open');
      button.setAttribute('aria-expanded', 'false');
    } else {
      // If closed, open it
      popover.setAttribute('open', '');
      button.setAttribute('aria-expanded', 'true');
    }
    
    // Prevent the default behavior that causes the double-click issue
    event.preventDefault();
    event.stopPropagation();
  }
  
  // Initialize the fix
  fixCountrySelectorDoubleClick();
  
  // Re-initialize when navigation drawer is loaded (for dynamic content)
  document.addEventListener('shopify:section:load', function(event) {
    if (event.detail.sectionId.includes('header') || event.detail.sectionId.includes('navigation')) {
      setTimeout(fixCountrySelectorDoubleClick, 100);
    }
  });
  
  // Also re-initialize when the drawer opens
  document.addEventListener('drawer:after-show', function() {
    setTimeout(fixCountrySelectorDoubleClick, 100);
  });
});
